<section class="qhse">
  <div class="qhse-header">
    <div class="text">
      <div class="title container">
        <h1 data-aos="fade-left">Confidentiality & Data Protection Commitment</h1>
      </div>
    </div>
  </div>
  <div class="qhse-content">
    <div class="container">
      <div class="row">
        <div class="title col-md-12">
          <h3 >Confidentiality & Data Protection Commitment</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-12 left">
          <p >
            UNICO are fully committed to protecting the confidentiality of all information obtained or generated during our inspection activities.
          </p>
          <hr>
          <p >
            All data, documents, reports, and records provided by our clients are treated as strictly confidential and are managed in accordance with ISO/IEC 17020:2012 requirements.
          </p>
          <hr>
          <p >
            We do not disclose any client information to third parties without prior written authorization, except where required by law or accreditation rules.
          </p>
          <h5>To ensure integrity and protection:</h5>
            <ol>
                <li>All inspection records are securely controlled, stored, and accessed only by authorized personnel.</li>
                <li>Confidential information is used exclusively for the purpose for which it was provided.</li>
                <li>All employees, subcontractors, and inspection personnel are bound by legally enforceable confidentiality obligations.</li>
                <li>Digital data is protected against unauthorized access, misuse, alteration, or loss.</li>
            </ol>
        </div>
        <div class="col-lg-6 col-md-12 right1">
          <img  src="../../../../assets/img/qhse/qhse-confidentiality.png" alt="">
        </div>
        <hr class="mt-4">
        <div  class="col-md-12 bottom">
            
          <p>
            UNICO Lifting Services maintains a zero-tolerance policy toward breaches of confidentiality and continuously reviews and strengthens data protection controls to uphold trust and compliance.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
